<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "UiChoiceModal",
  components: {
    ModalWrapperChoice
  },
  computed: {
    listEntries() {
      return [
        `Больше событий теперь имеют анимации. Если они влияют на вашу производительность или геймплей, они могут быть
        отключены в Настройках.`,
        `Новые окна подтверждений были заменены стандартными сигналами JavaScript. Они могут быть отключены в подвкладке
        Настройки Геймплея во вкладке Настроек.`,
        "Теперь игра имеет болеее элегантную разметку."
      ];
    }
  },
  methods: {
    handleYesClick() {
      GameOptions.toggleUI();
    },
  },
};
</script>

<template>
  <ModalWrapperChoice @confirm="handleYesClick">
    <template #header>
      Визуальные Изменения
    </template>
    <div class="c-modal-message__text">
      Мы заметили, что вы загрузили старое сохранение;
      несколько визуальных изменений было произведено с выхода старой версии игры:
      <br>
      <br>
      <div class="c-visual-change-list">
        <div
          v-for="(entry, i) in listEntries"
          :key="i"
          class="c-visual-change-list-entry"
        >
          <b>&bull;</b>
          {{ entry }}
        </div>
      </div>
      <br>
      <br>
      Вы можете переключать классическую версию интерфейса и современную в подвкладке Визуальные Изменения в настройках
      в любое время. Хотите ли вы переключиться на современный интерфейс прямо сейчас?
    </div>
    <template #cancel-text>
      Оставить
    </template>
    <template #confirm-text>
      Переключить
    </template>
  </ModalWrapperChoice>
</template>

<style scoped>
.c-visual-change-list {
  display: inline-block;
  max-width: 45rem;
  text-align: left;
}

.c-visual-change-list-entry {
  display: flex;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
</style>
